module.exports = __webpack_public_path__ + "img/p1.32619c6a.png";